import { EntityState } from '@ngrx/entity';

export interface ILotCommon {
  unitId: number;
  strataPlanNumber: string; // same as UI store's strataPlanNumber
  unitType: string; // same as UI store's isLot (but not boolean)
  unitNumber: string;
  lotNumber: string;
  isParent: boolean | null; // for linking
  linkingNumber: number | null; // for linking
  rentalAgentId: number | null;
  ownerDetail: OwnerDetail;
  tenantDetail: TenantDetail;
  committeeDetail: CommitteeDetail;
  isOwnerOccupied: boolean;
  isCommitteeMember: boolean;
  linkedLots: LinkedLot [];
  groupedLots: GroupedLot [];
  propertyName: string;
  streetAddress: string;
  groupNumber: number;
}

export interface ILotTable extends EntityState<ILotCommon> {
  selectedUnitId: number;
}

export function selectUnitId(a: ILotCommon): number {
  return a.unitId;
}

export interface OwnerDetail {
  firstName: string;
  lastName: string;
  title: string;
  isCompanyOwner: boolean;
  possessionDate: Date;
  ownerAddressPhone: AddressPhone;
  billingAddressPhone: AddressPhone;
  mailingOptions: MailingOption;
}

export interface TenantDetail {
  name: string;
  tenantAddressPhone: AddressPhone;
  term: string | null;
  termStartDate: Date | string;
  termEndDate: Date | string;
}

export interface CommitteeDetail {
  firstName: string;
  lastName: string;
  companyAddressPhone: AddressPhone;
}

export interface AddressPhone {
  freeTextAddress: string;
  address1: string;
  address2: string;
  address3: string;
  suburb: string;
  state: string;
  postCode: number;
  mobile: number;
  alternateMobile: string | null;
  businessPhone: string | null;
  homePhone: string | null;
  levyEmail: string | null;
  email: string | null;
}

export interface MailingOption {
  levyNoticeAddress: string;
  correspondenceAddress: string;
  correspondenceTo: string;
  sendLevyNoticesByEmail: boolean;
  sendCorrespondenceByEmail: boolean;
}


export interface LinkedLot {
  unitNumber: string;
  lotNumber: string;
}

export interface GroupedLot {
  unitNumber: string;
  lotNumber: string;
  parent: boolean;
  strataPlanNumber: string;
}

